export const servicesDB = [
    {
          _id: 0,
        img: '/img/Pediatrics.jpg',
        title: 'Pediatrics',
        description: 'At Medicare Health, we partner with families to deliver expert, compassionate care to infants, children and teens.'
    },
    {
          _id: 1,
          img: 'https://www.fi.edu/sites/default/files/styles/featured_large/public/General_EduRes_Heart_MilestonesInCardiology.jpg?itok=p4WKfw99',
        title: 'Cardiology',
        description: 'Our comprehensive heart services include general and preventive cardiology, cardiac testing and imaging, specialized cardiology and cardiac surgery.'
    },
    {
          _id: 2,
          img: 'https://cdn0.scrvt.com/39b415fb07de4d9656c7b516d8e2d907/1800000007393322/c65c3fb075bd/v/8fad22531fe1/neurosurgery_header_image_1800000007393322.jpg',
        title: 'Neurosurgery',
        description: 'Our top-rated neurosurgeons use advanced imaging and surgical techniques to treat neurological conditions, such as brain tumors and traumatic brain injury.'
    },
    {
          _id: 3,
          img: 'https://www.iaea.org/sites/default/files/styles/width_555px_6_units_16_9/public/radiation-therapy-1140x640.jpg?itok=iH_QCNfm',
        title: 'Cancer Care',
        description: 'Medicare Health patients can expect comprehensive and individualized cancer care, delivered in convenient locations across Southern California.'
    },
    {
          _id: 4,
          img: 'https://bhtclinic.com.tr/wp-content/uploads/2019/07/goz-sagligi-ve-hastaliklari.jpg',
        title: 'Ophthalmology',
        description: 'Since we founded our program, our ophthalmology team has consistently ranked among the best in the country.'
    },
    {
          _id: 5,
          img: 'https://www.verywellhealth.com/thmb/oBsMQW3fksGT3xoeRdID8-wRtQI=/800x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/GettyImages-1208369994-b837c1c8605445c5972c4c7ce442fe61.jpg',
        title: 'Pulmonology',
        description: 'Our pulmonology, critical care and sleep medicine team provides world-class care.'
    }
]

